export default __webpack_public_path__ + "locales/el-GR/Article.json?hash=abc87b50e6734cf1ba56ffae966c49fa";